import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export function pushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "unsupported";
}

async function getRegistration() {
  const reg = await navigator.serviceWorker.getRegistration();
  return reg || navigator.serviceWorker.register("/sw.js");
}

// Demande la permission puis enregistre l'abonnement côté serveur.
export async function enablePush() {
  if (!pushSupported()) throw new Error("unsupported");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("denied");

  const reg = await getRegistration();
  await navigator.serviceWorker.ready;

  const { data } = await api.get("/push/vapid-public-key");
  const key = data?.public_key;
  if (!key) throw new Error("no-key");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

// Ré-enregistre silencieusement un abonnement déjà autorisé (au login / au chargement).
export async function syncPush() {
  if (!pushSupported() || pushPermission() !== "granted") return false;
  try {
    const reg = await getRegistration();
    await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public-key");
    const key = data?.public_key;
    if (!key) return false;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      });
    }
    await api.post("/push/subscribe", { subscription: sub.toJSON() });
    return true;
  } catch {
    return false;
  }
}
